module.exports = __webpack_public_path__ + "images/goldcam4-ff444db1543010a7f4e02bbeac8dc473.png";